import { axiosInstance as axios } from "services";

export const fetchAllUom = async (params) => {
  const { data } = await axios.get("/pricing/master/material/uom", { params });
  if (!data.success) throw new Error(data.error || "Failed to fetch UOM data");
  return data;
};

